export const CampaignsParser = (data: any, metaInfo: any) => {
  const retData: any = []

  const getValueMetaInfo = (key: any, type: string) => {
    const values = metaInfo.filter((item: any) => type === item.type)?.[0]?.values
    return values?.find((item: any) => item?.id === Number(key))?.value ?? ''
  }
  data?.map((item: any, index: number) => {
    const retItem = {
      cId: item?.offerCode ?? index,
      title: item?.offerName,
      startDate: item?.startDate ?? '',
      endDate: item?.endDate ?? '',
      type: getValueMetaInfo(item?.offerType, 'rewardType') ?? 'NA',
      status: getValueMetaInfo(item?.status, 'status') ?? 'NA',
      rewardsDistribution: {
        rewardsDistributed: item?.rewardsDistributed ?? '',
        distributionCount: item?.distributionCount ?? '',
        percentage: item?.distribution?.distributionPercentage ?? '',
      },
      offer: {
        maxBudget: item?.offer?.maxOfferDiscount ?? 0,
        offerMaxCount: item?.offer?.maxCount ?? 0,
        txnAmountRange: item?.offer?.maxOrderAmt ?? '',
      },
      paymentModes: item?.method?.subType ?? 0,
      cardTypes: item?.method?.values?.bins ?? '',
      discount: getValueMetaInfo(item?.offerType, 'rewardType') ?? 'NA',
      discountType: 'NA',
      value: 0,
      issueFrequency: 'NA',
      issueCountPerUser: 0,
    }
    retData.push(retItem)
  })
  return retData
}
